// extracted by mini-css-extract-plugin
export default {"card":"ESIMLocation_card__73Boz","cardActive":"ESIMLocation_cardActive__qoThR"};